import { extendTailwindMerge } from 'tailwind-merge';

/**
 * LES ROLES TYPOGRAPHIQUES, ceux que `app/globals.css` declare en `--text-*`.
 *
 * Ils sont recopies ici, et c'est ce que la fusion de classes a besoin de savoir. Voir le motif
 * complet sous `cn`.
 */
const TAILLES_DE_TEXTE = [
  'titre-page',
  'chapo-page',
  'titre-section',
  'chapo-section',
  'surtitre',
  'intertitre',
  'corps',
  'chiffre',
  'citation',
  'attribution',
  'legende',
  'etiquette',
  // AJOUTE LE 2026-08-13, APRES QUE LA PANNE DECRITE PLUS BAS S'EST PRODUITE. Le role `index` a ete
  // ajoute a `app/globals.css` par la v3 sans etre declare ici : `tailwind-merge` le classait donc
  // en COULEUR, et l'effacait des qu'une couleur de texte suivait dans le meme appel. Mesure sur la
  // page servie : la classe rendue de l'index d'une carte etait `font-structure font-medium
  // tracking-index text-bordure-forte`, sans `text-index`, et le chiffre se rendait a 16 pixels au
  // lieu de 12. Le sur-titre y echappait par accident, en heritant les 12 pixels de son parent.
  'index',
  'bouton',
  'navigation',
  'reperes',
] as const;

/** Les roles de couleur qui peuvent se poser sur du texte, declares en `--color-*`. */
const COULEURS_DE_TEXTE = [
  'texte-fort',
  'texte-courant',
  'texte-doux',
  'texte-inverse',
  'texte-accent',
  'action',
  'action-survol',
  'ornement',
  'ornement-clair',
  'bordure',
  'bordure-forte',
  'focus',
] as const;

/**
 * La fusion de classes Tailwind, configuree pour le vocabulaire de ce depot.
 *
 * POURQUOI CE N'EST PAS UNE CONCATENATION. `` `p-4 ${classe}` `` avec `classe = 'p-8'` produit
 * `p-4 p-8` : les deux regles ont la meme specificite, et c'est l'ordre dans la feuille compilee
 * qui tranche, pas l'ordre dans la chaine. Le composant croit donner un defaut surchargeable, il
 * donne en realite un resultat imprevisible. La fusion retire `p-4` et garde `p-8`.
 *
 * POURQUOI ELLE EST CONFIGUREE, ET CE QUE COUTAIT DE NE PAS LA CONFIGURER. `tailwind-merge` ne lit
 * pas la feuille de style : il reconnait les utilitaires par leur NOM, et ses noms sont ceux des
 * defauts de Tailwind. Devant `text-titre-page` et `text-texte-fort`, il voit deux classes qui
 * commencent par `text-`, en conclut qu'elles se contredisent, et **garde la derniere**. La taille
 * disparaissait donc au profit de la couleur.
 *
 * CE QUE CELA DONNAIT A L'ECRAN, mesure le 2026-08-13 : le titre du haut de page, prescrit entre 40
 * et 68 pixels par spec-design.md v2, se rendait a la taille par defaut du navigateur. Les 15 roles
 * de l'echelle typographique etaient perdus partout ou un composant posait une taille ET une
 * couleur, c'est-a-dire dans la quasi-totalite d'entre eux. **Aucun test ne l'a vu** : les criteres
 * de ce sprint mesurent des fonds, des positions, des comptes et des ratios de contraste, aucun ne
 * mesure une taille de police rendue. C'est un defaut que seule la revue visuelle attrape, et c'est
 * exactement ce que la tache 04-03 doit faire.
 *
 * Les deux listes ci-dessus disent a l'outil quels noms sont des TAILLES et quels noms sont des
 * COULEURS. Elles se tiennent a jour avec `app/globals.css` : un role ajoute la-bas et oublie ici
 * se ferait de nouveau effacer en silence.
 */
const fusionne = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [{ text: [...TAILLES_DE_TEXTE] }],
      'text-color': [{ text: [...COULEURS_DE_TEXTE] }],
    },
  },
});

export function cn(...classes: (string | false | null | undefined)[]): string {
  return fusionne(classes.filter(Boolean).join(' '));
}
